import { Pipe, PipeTransform } from '@angular/core';
import memoize from '@github/memoize/decorator';
import { StringUtils } from '../utils/string';

@Pipe({ name: 'titleCase' })
export class TitleCasePipe implements PipeTransform {
  @memoize()
  public transform(value?: null | string): string {
    return StringUtils.titleCase(value || '');
  }
}
